import {
    Policy,
    Renewal,
    PREMIUM_TYPE_MONTHLY,
    ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL
} from "@falcon/services";
import * as React from "react";
import {StorageSuccessModal} from "./StorageSuccessModal";
import {Link} from "react-router-dom";
import {formatDateDMY} from "../../CommonFunctions";
import {
    EditCarMtaSuccessModalWordingGenerator
} from "../../pages/dashboard/annual/motor/yourCarsPage/modal/EditCarMtaSuccessModalWordingGenerator";
import DirectDebitPaymentSchedule from "../widgets/DirectDebitPaymentSchedule"

interface IProps {
    currentPolicy: Policy;
    renewalProposal: Renewal;
    hideManualRenewalConfirmation: () => void;
}

interface IState {
    isOpen: boolean;
    isInstalmentPlanOpened: boolean;
    monthlyPayments: boolean;
}

export class AnnualHomeManualRenewalConfirmation extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: true,
            isInstalmentPlanOpened: false,
            monthlyPayments: this.props.renewalProposal.factors.premiumType === PREMIUM_TYPE_MONTHLY
        };

        this.close = this.close.bind(this);
    }

    public render(): React.JSX.Element {
        const modalTitle: React.ReactNode = <h1 className="mb-0">You've renewed!</h1>;
        const renewalStartDate: string | null = formatDateDMY(this.props.renewalProposal.renewalDetails.periodStartDate);

        return (
            <>
                {<StorageSuccessModal
                    title={modalTitle}
                    onClose={this.close}
                    explanationWording={
                        <div className="font-and-line-styles">
                            <div className="mb-4 font-weight-700">
                                <div>Your home insurance policy is now scheduled to renew on {renewalStartDate}.</div>
                                <div>You do not need to inform us of the change by email or do anything else.</div>
                            </div>
                            <p>You can still <Link
                                className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                                to={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.props.renewalProposal._id}>
                                make changes
                            </Link> up to your renewal date.</p>
                            <div className="mt-4 mb-4">
                                {this.state.monthlyPayments && this.monthlyInfo()}
                                {!this.state.monthlyPayments && this.annualInfo()}
                            </div>
                        </div>
                    }
                    anythingElseTitle={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle()}
                    explanationAnythingElseWording={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody()}
                    passFontAndLineStyles={"font-and-line-styles"}
                    passMarginTopStyle={"margin-top-9em"}/>
                }
            </>
        )
    }

    private monthlyInfo(): React.JSX.Element {
        const renewalProposal: Renewal = this.props.renewalProposal
        const instalmentPlan: any = renewalProposal.paymentDetails.instalmentPlan;
        const monthlyPayerInitialPaymentDate: string | null = formatDateDMY(renewalProposal.renewalDetails.monthlyPayerInitialPaymentDate);
        const currentPolicyInteraction: any = this.props.currentPolicy.interaction;
        const firstInstallmentPayAmount = instalmentPlan.instalments[0].principal + instalmentPlan.instalments[0].interest;

        return <>
            <p className="mb-4">The first instalment of <span className="font-weight-bold">£{firstInstallmentPayAmount.toFixed(2)}</span> will be taken
                on {monthlyPayerInitialPaymentDate}. Please check your payment schedule below.</p>
            <label htmlFor="paymentScheduleTable" className="text-center">
                <div className="font-weight-700 mt-1">Payment schedule</div>
            </label>
            <p className="mb-2 mt-1">You have to pay a total of <span
                className="font-weight-bold">£{instalmentPlan.totalAmount} </span>
                ({instalmentPlan.instalments.length} instalments X {instalmentPlan.monthlyPayment})</p>
            <div id="paymentScheduleTable" className="mb-3 mt-3">
                <DirectDebitPaymentSchedule
                    isOpen={this.state.isInstalmentPlanOpened}
                    instalments={instalmentPlan.instalments || []}
                    interaction={currentPolicyInteraction}
                />
            </div>
            <div className="text-left mt-4">
                {!this.state.isInstalmentPlanOpened ?
                    <button
                        className="btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-4"
                        onClick={this.toggleInstallmentPlan}>
                        + <span className="text-decoration-underline">View instalments plan</span>
                    </button>
                    :
                    <button
                        className="btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-4"
                        onClick={this.toggleInstallmentPlan}>
                        - <span className="text-decoration-underline">Hide instalments plan</span>
                    </button>
                }
            </div>
        </>;
    }

    private annualInfo(): React.JSX.Element {
        const renewalStartDate: string | null= formatDateDMY(this.props.renewalProposal.renewalDetails.annualPayerInitialPaymentDate);
        const cardEnding: string = this.props.currentPolicy.interaction.policyHolder.cardDetails?.at(-1)?.number.slice(-4);

        return <>£{this.props.renewalProposal.factors.annualPremium} will be taken from your card
            ending in {cardEnding} on {renewalStartDate}.
            Please <Link className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                         to={"/dashboard/annualPaymentHistory/" + this.props.currentPolicy.policyNumber}>{' '}check your
                payment card</Link> is still valid.</>;
    }

    private close(): void {
        this.setState((prevState: Readonly<IState>) =>
            ({isOpen: !prevState.isOpen})
        )
        this.props.hideManualRenewalConfirmation()
    }

    private toggleInstallmentPlan = (): void => {
        this.setState((prevState: Readonly<IState>) => (
            {isInstalmentPlanOpened: !prevState.isInstalmentPlanOpened})
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/AnnualHomeManualRenewalConfirmation.tsx